var map = {
	"./WhatsApp Image 2024-12-03 at 4.39.40 PM.jpeg": 2186,
	"./WhatsApp Image 2024-12-03 at 4.39.41 PM (1).jpeg": 13269,
	"./WhatsApp Image 2024-12-03 at 4.39.41 PM.jpeg": 62207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76592;